<ng-container [ngSwitch]="LayoutService.layout$ | async">
  <app-dms *ngSwitchCase="Layout.DMS">
    <router-outlet />
  </app-dms>

  <app-esign *ngSwitchDefault>
    <router-outlet />
  </app-esign>
</ng-container>
